import { useState, useEffect } from 'react';

import { BackgroundTask } from 'controllers/types';
import consumer from '../../channels/consumer';

export function useProgressBarChannel(task?: BackgroundTask) {
  const [taskData, setTaskData] = useState({
    status: task?.status,
    message: task?.message,
    // can add progress percentage and other task data once that's supported on the backend
  });

  useEffect(() => {
    const statusStates = ['', 'started'];
    if (task !== undefined && statusStates.some(s => task?.status === s)) {
      const channel = consumer.subscriptions.create(
        {
          channel: 'ProgressBarChannel',
          task_id: task.id,
        },
        {
          received(data: BackgroundTask) {
            setTaskData({
              status: data.status,
              message: data.message,
            });
          },
        },
      );
      return () => {
        channel.unsubscribe();
        consumer.disconnect();
      };
    }
  }, [task]);

  return taskData;
}
